import styled from "styled-components";
import { useEffect, useState } from "react";
import { useNavigate } from "react-router-dom";
import moment from "moment";

import useDisplay from "../../../hooks/useDisplay";
import LSRgH1HeadLine from "../../molecules/text/linSeedKr/Rg/lsRgH1HeadLine";
import LSBdDisplay02 from "../../molecules/text/linSeedKr/Bd/lsBdDisplay02";
import { route } from "../../../router/route";
import { fileUrl } from "../../../api/api";
import { formatNumberWithCommas } from "../../../util/formatNumber";
import ColumnApi from "../../../api/column.api";
import { errorHandler } from "../../../util/errorHandler";
import { toast } from "react-toastify";

function ColumnItemPage({ data, categoryValue }) {
  const navigate = useNavigate();
  const { isMobile, isTablet } = useDisplay();
  const isSmall = isMobile || isTablet;
  const [isScrap, setIsScrap] = useState(data.isScrap);
  const [scrapCount, setScrapCount] = useState(data.scrapCount);
  const [isScrapProcessing, setIsScrapProcessing] = useState(false);

  useEffect(() => {
    setIsScrap(Boolean(data.isScrap));
    setScrapCount(Number(data.scrapCount) || 0);
  }, [data.id, data.isScrap, data.scrapCount]);

  const scrapFunc = async () => {
    if (isScrapProcessing) return;
    if (sessionStorage.getItem("isLogin") !== "true") {
      toast("스크랩하려면 로그인을 해주세요.");
      navigate(route.login, { state: { path: window.location.href } });
      return;
    }

    setIsScrapProcessing(true);
    try {
      const requestData = {
        columnPostId: data.id,
      };

      await ColumnApi.putScrap(requestData);

      setIsScrap((prev) => !prev);
      setScrapCount((prev) => Math.max(0, prev + (isScrap ? -1 : 1)));
    } catch (error) {
      errorHandler(error);
    } finally {
      setIsScrapProcessing(false);
    }
  };

  return (
    <div
      style={{
        width: isMobile ? "46.8%" : isTablet ? "48%" : "380px",
        height: isMobile ? "200px" : "480px",
      }}
    >
      <div
        style={{
          borderRadius: 15,
          overflow: "hidden",
        }}
      >
        <BackgroundImageContainer
          isSmall={isSmall}
          isMobile={isMobile}
          isTablet={isTablet}
          backgroundImage={`${fileUrl}/${data.thumbnailServerFileNameColumn}`}
          onClick={() => {
            if (categoryValue > 0) {
              navigate(`${route.column_detail}/${data.id}`, {
                state: { categoryValue: categoryValue },
              });
            } else {
              navigate(`${route.column_detail}/${data.id}`);
            }
          }}
        >
          <ScrapButton
            isMobile={isMobile}
            aria-disabled={isScrapProcessing}
            onClick={(e) => {
              e.stopPropagation(); // 이벤트 전파 중단
              scrapFunc();
            }}
          >
            <img
              src={
                isScrap
                  ? "/assets/icons/bookmark_a.png"
                  : "/assets/icons/bookmark_d.png"
              }
              alt="bookmark"
            />
            <LSRgH1HeadLine
              style={{
                fontSize: isMobile ? 10 : 16,
                lineHeight: isMobile ? "12px" : "22.4px",
                color: "#ffffff",
                marginTop: isMobile ? 4 : 8,
              }}
            >
              {formatNumberWithCommas(scrapCount)}
            </LSRgH1HeadLine>
          </ScrapButton>
          <ProductTitle
            style={{
              fontSize: isMobile ? 16 : 24,
              lineHeight: isMobile ? "22.4px" : "33.6px",
              marginBottom: isMobile ? 8 : 18,
            }}
          >
            {data.title}
          </ProductTitle>
          <LSRgH1HeadLine
            style={{
              fontSize: isMobile ? 12 : 16,
              lineHeight: isMobile ? "14.4px" : "22.4px",
              color: "#ffffff",
            }}
          >
            {moment(data.createdAt).format("YYYY.MM.DD")}
          </LSRgH1HeadLine>
        </BackgroundImageContainer>
      </div>
    </div>
  );
}

export default ColumnItemPage;

// 스타일 컴포넌트
const BackgroundImageContainer = styled.div`
  display: flex;
  flex-direction: column;
  justify-content: flex-end;
  position: relative;
  cursor: pointer;
  background-image: ${({ backgroundImage }) => `url(${backgroundImage})`};
  background-position: center;
  background-size: cover;
  background-repeat: no-repeat;
  border-radius: 15px;

  padding: ${({ isSmall }) => (isSmall ? "20px 11px" : "40px")};

  width: 100%;
  height: ${({ isMobile }) => (isMobile ? "200px" : "480px")};

  background-color: #0000004d;

  &:hover {
    transform: scale(1.04); /* 확대 효과 */
    transition: transform 0.3s ease-in-out; /* 부드러운 애니메이션 */
  }
`;

const ScrapButton = styled.div`
  position: absolute;
  right: ${({ isMobile }) => (isMobile ? "12px" : "25px")};
  top: ${({ isMobile }) => (isMobile ? "20px" : "47px")};
  display: flex;
  flex-direction: column;
  align-items: center;
  cursor: pointer;
  z-index: 4;

  img {
    height: ${({ isMobile }) => (isMobile ? "24px" : "42px")};
    width: ${({ isMobile }) => (isMobile ? "24px" : "42px")};
  }
`;

const ProductTitle = styled(LSBdDisplay02)`
  color: #ffffff;
  text-overflow: ellipsis;
  overflow: hidden;
  word-break: break-word;

  display: -webkit-box;
  -webkit-line-clamp: 2; /* 원하는 라인수 */
  -webkit-box-orient: vertical;
`;
